import {createEditorPriority} from './priority.types'

export const corePriority = createEditorPriority({name: 'core'})
